<template>
  <div class="home">
    <BackButton @click="goBack" />
    <div class="slider-block">
      <div class="slider" :class="{ 'move-right': activeMode === 'active' }"></div>
      <p class="filter-tab" :class="{ activeBlock: activeMode === 'all' }" @click="changeActive('all')">
        {{ $t("all") }} <span>{{ totalCompetitions }}</span>
      </p>
      <p class="filter-tab" :class="{ activeBlock: activeMode === 'active' }" @click="changeActive('active')">
        {{ $t("active") }} <span>{{ activeCompetitions }}</span>
      </p>
    </div>

    <div class="loading" v-if="loading">
      <p>{{ $t("loading") }}</p>
    </div>

    <div class="competitionsList" v-else>
      <div v-for="competition in activeMode === 'all' ? competitions : actCompetitions" :key="competition.id" class="competition" :class="{ inactive: competition.status === 'ended' }" @click="goToCompetition(competition.id)">
        <div class="competition_banner">
          <img :src="competition.banner_url" width="100%" />
          <span>{{ competition.title }}</span>
        </div>
        <div class="competitionText">
          <div class="competitionInfo">
            <p class="competitionHead">{{ competition.title }}</p>
            <p class="competitionDesc">{{ competition.description }}</p>
            <!-- <div class="competitionMeta">
              <span class="participants">{{ competition.participants_count }} {{ $t("participants") }}</span>
              <span class="prize">{{ competition.prize_amount }} {{ competition.prize_currency }}</span>
            </div>
            <div class="competitionDates">
              <span class="dates">{{ formatDate(competition.start_date) }} - {{ formatDate(competition.end_date) }}</span>
            </div> -->
          </div>

          <svg v-if="competition.status === 'active'" xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 500 500">
            <g transform="matrix(13.773586, 0, 0, 13.773586, -2161.685059, -965.446106)">
              <rect x="165.772" y="78.992" width="18" height="18" fill="white"></rect>
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M 175.108 106.192 C 165.213 106.192 157.191 98.17 157.191 88.275 C 157.191 78.38 165.213 70.358 175.108 70.358 C 185.003 70.358 193.025 78.38 193.025 88.275 C 193.025 98.17 185.003 106.192 175.108 106.192 Z M 168.441 87.525 C 168.027 87.525 167.691 87.861 167.691 88.275 C 167.691 88.689 168.027 89.025 168.441 89.025 L 179.964 89.025 L 176.244 92.745 C 175.952 93.038 175.952 93.512 176.244 93.805 C 176.537 94.098 177.012 94.098 177.305 93.805 L 182.305 88.805 C 182.446 88.665 182.525 88.474 182.525 88.275 C 182.525 88.076 182.446 87.885 182.305 87.745 L 177.305 82.745 C 177.012 82.452 176.537 82.452 176.244 82.745 C 175.952 83.038 175.952 83.512 176.244 83.805 L 179.964 87.525 L 168.441 87.525 Z"
                style="fill: rgb(0, 122, 255)"
              ></path>
            </g>
          </svg>
        </div>

        <button v-if="competition.status === 'ended'" class="showResults">
          {{ $t("show-results") }}
        </button>

        <!-- <div v-if="competition.status === 'active'" class="competitionStatus">
          <span v-if="competition.is_registered" class="registered">✓ {{ $t("registered") }}</span>
          <span v-else class="not-registered">{{ $t("not-registered") }}</span>
        </div> -->

        <div v-if="competition.status === 'upcoming'" class="competitionStatus">
          <span class="upcoming">{{ $t("upcoming") }}</span>
        </div>
      </div>

      <div v-if="competitions.length === 0" class="no-competitions">
        <p>{{ $t("no-competitions") }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { BackButton } from "vue-tg";
import axios from "axios";
import { UserManager } from "@/utils/userManager";
import { getDateLocale } from "@/utils/apiErrors";

export default {
  name: "CompetitionsPage",
  data() {
    return {
      activeMode: "all",
      competitions: [],
      actCompetitions: [],
      loading: true,
      error: null,
      userId: null,
      botId: null,
    };
  },
  computed: {
    totalCompetitions() {
      return this.competitions.length;
    },
    activeCompetitions() {
      return this.competitions.filter((c) => c.status === "active").length;
    },
  },
  async mounted() {
    const userContext = UserManager.getFullUserContext();
    this.userId = userContext.user.id;
    this.botId = userContext.botId;
    this.$store.commit("setBotId", this.botId);
    this.$store.commit("setTgUserData", userContext.user);

    await this.loadCompetitions();
  },
  methods: {
    async loadCompetitions() {
      try {
        this.loading = true;
        // Убеждаемся, что bot_id есть
        if (!this.botId) {
          const userContext = UserManager.getFullUserContext();
          this.botId = userContext.botId;
          this.$store.commit("setBotId", this.botId);
        }
        
        console.log("Загружаем конкурсы с параметрами:", {
          status: this.activeMode,
          user_id: this.userId,
          bot_id: this.botId,
        });
        const response = await axios.get(`${window.location.origin}/rcompetitions/list`, {
          params: {
            status: this.activeMode,
            user_id: this.userId,
            bot_id: this.botId,
          },
        });

        console.log("Ответ API:", response.data);

        if (response.data.success) {
          this.competitions = response.data.competitions;
          console.log("Загружено конкурсов:", this.competitions.length);
        } else {
          console.error("API вернул ошибку:", response.data);
          this.error = this.$t("error-loading-competitions");
        }
      } catch (error) {
        console.error("Ошибка загрузки конкурсов:", error);
        this.error = this.$t("network-error");
      } finally {
        this.loading = false;
      }
    },

    async changeActive(mode) {
      if (this.activeMode === mode) return;

      this.activeMode = mode;
      // await this.loadCompetitions()
      this.actCompetitions = this.competitions.filter((c) => c.status === "active");
      let slider = document.querySelector(".slider");
      if (mode === "active") {
        slider.classList.add("move-right");
      } else {
        slider.classList.remove("move-right");
      }
    },

    goBack() {
      window.history.back();
    },

    goToCompetition(competitionId) {
      this.$router.push(`/competitions/${competitionId}`);
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString(getDateLocale(this.$store.getters.getLanguage), {
        day: "2-digit",
        month: "2-digit",
      });
    },
  },
  components: { BackButton },
};
</script>

<style scoped>
.home {
  padding: 5% 3% 5% 3%;
  display: flex;
  flex-direction: column;
  gap: 2vh;
  background-color: var(--background-color);
  height: 100vh;
  max-width: 100vw;
}

.slider-block {
  font-size: 14px;
  display: flex;
  margin: 0 auto;
  background-color: var(--button-background);
  border-radius: 50px;
  position: relative;
  padding: 5px 10px 5px 10px;
}

.filter-tab {
  padding: 5px 20px 5px 20px;
  flex: 1;
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  z-index: 1;
  color: #737376;
  cursor: pointer;
}

.filter-tab span {
  color: #999999;
}

.slider {
  background-color: var(--slider-color);
  width: 40%;
  height: 70%;
  position: absolute;
  left: 2%;
  top: 50%;
  transform: translateY(-50%);
  z-index: 0;
  border-radius: 50px;
  transition: left 0.3s, width 0.3s;
}

.slider.move-right {
  left: 40%;
  width: 55%;
}

.activeBlock {
  color: var(--text-color1) !important;
}

.loading {
  text-align: center;
  padding: 2rem;
}

.competitionsList {
  display: flex;
  flex-direction: column;
  gap: 15px;
  overflow-y: auto;
}
.competition_banner {
  position: relative;
}
.competition_banner span {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: 20px;
  font-family: "SF Pro Text Bold";
  color: white;
  padding: 5%;
  max-width: 60%;
  text-align: left;
}
.competition {
  background-color: var(--second-color);
  border-radius: 14px;
  display: flex;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
}

.competition:hover {
  transform: translateY(-2px);
}

.competition img {
  border-radius: 14px 14px 0 0;
  height: 9em;
  width: 100%;
  object-fit: cover;
}

.competitionInfo {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.competitionText {
  display: flex;
  text-align: left;
  padding: 5%;
  align-items: center;
  justify-content: space-between;
}

.competitionHead {
  color: var(--black-to-white);
  font-size: 17px;
  font-family: "SF Pro Text Bold";
}

.competitionDesc {
  font-size: 14px;
  color: #737373;
}

.competitionMeta {
  display: flex;
  gap: 15px;
  margin-top: 5px;
  font-size: 12px;
}

.competitionDates {
  margin-top: 5px;
  font-size: 11px;
}

.participants {
  color: #007aff;
}

.prize {
  color: #27c12d;
  font-weight: bold;
}

.dates {
  color: #999;
}

.competitionStatus {
  padding: 0 5% 5% 5%;
}

.registered {
  color: #27c12d;
  font-size: 14px;
  font-weight: bold;
}

.not-registered {
  color: #ff9500;
  font-size: 14px;
}

.upcoming {
  color: #007aff;
  font-size: 14px;
}

.showResults {
  background-color: #007aff;
  border-radius: 10px;
  border: 1px solid transparent;
  color: white;
  font-size: 16px;
  padding: 10px;
  width: 95%;
  margin: 0 auto;
  margin-bottom: 5%;
  z-index: 3;
  cursor: pointer;
}

.inactive::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--white-to-black);
  opacity: 0.5;
  border-radius: 14px;
}

.no-competitions {
  text-align: center;
  padding: 2rem;
  color: #737373;
}
</style>
